// extracted by mini-css-extract-plugin
export default {"total":"pieChart_total__MI8xq"};